import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useQueryClient } from "react-query";
import Icon from "@mdi/react";
import { mdiChevronRight, mdiTrashCanOutline } from "@mdi/js";

import { useToast } from "../../context/ToastContext";
import { ParameterGetParametersResponse } from "../../entities/ParameterEntity";
import ParameterService from "../../services/ParameterService";

import ListCard from "../ListCard";
import { Unpacked } from "../../config/defines";

type ParametrosCardPropsContent = {
	data: Unpacked<ParameterGetParametersResponse>;
	skeleton?: never;
};

type ParametrosCardPropsSkeleton = {
	data?: never;
	skeleton: true;
};

type ParametrosCardProps = ParametrosCardPropsContent | ParametrosCardPropsSkeleton;

const toastTitle = "Parâmetro";

export default function ParametrosCard(props: ParametrosCardProps) {
	const parameterService = new ParameterService();

	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { handleToast } = useToast();

	const [removeModal, setRemoveModal] = useState(false);
	const [removeLoadingModal, setRemoveLoadingModal] = useState(false);
	const [removed, setRemoved] = useState(false);

	function handleClick() {
		if (!props.skeleton && props.data) {
			navigate("/parametroFormulario/" + props.data.id);
		}
	}

	function handleClickRemove(e: any) {
		e.stopPropagation();
		setRemoveModal(true);
	}

	async function handleRemove() {
		if (!props.skeleton && props.data) {
			setRemoveLoadingModal(true);
			let resp = await parameterService.delete(props.data.id!);
			if (resp.status === 200) {
				queryClient.invalidateQueries(["parametros"]);
				setRemoved(true);
			} else {
				handleToast(toastTitle, resp.statusText, 5000, "danger");
			}
			setRemoveModal(false);
			setRemoveLoadingModal(false);
		}
	}

	function handleCloseModal() {
		if (!removeLoadingModal) {
			setRemoveModal(false);
		}
	}

	let skeletonButton = "";
	if (props.skeleton) {
		skeletonButton = "skeleton skeleton-button";
	}

	if (removed) {
		return <></>;
	}

	return (
		<>
			<ListCard onClick={handleClick}>
				<ListCard.Content>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Nome</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.title ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Importância Técnica</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.technicalImportance ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Importância Funcional</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.functionalImportance ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Valor Máximo</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.maxValue ?? "..."}</ListCard.Text>
					</ListCard.Item>
				</ListCard.Content>
				<ListCard.Action>
					<Button variant="light" className={`me-2 ${skeletonButton}`} onClick={handleClickRemove}>
						<Icon path={mdiTrashCanOutline} size={1} className="text-danger" />
					</Button>
					<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
				</ListCard.Action>
			</ListCard>

			<Modal show={removeModal} onHide={handleCloseModal} centered>
				<Modal.Header closeButton>
					<Modal.Title>Remover Grupo</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">{!removeLoadingModal ? "Deseja realmente remover este grupo?" : <Spinner />}</Modal.Body>
				{!removeLoadingModal && (
					<Modal.Footer>
						<Button variant="secondary" onClick={handleCloseModal}>
							Cancelar
						</Button>
						<Button variant="danger" onClick={handleRemove}>
							Remover
						</Button>
					</Modal.Footer>
				)}
			</Modal>
		</>
	);
}
